if (!customElements.get('pdp-countdown')) {
  class PdpCountdown extends HTMLElement {
    connectedCallback() {
      this.endDate = new Date(this.getAttribute('data-end-date'));
      if (isNaN(this.endDate.getTime())) return;

      this.daysEl = this.querySelector('[data-countdown-days]');
      this.hoursEl = this.querySelector('[data-countdown-hours]');
      this.minutesEl = this.querySelector('[data-countdown-minutes]');
      this.secondsEl = this.querySelector('[data-countdown-seconds]');

      this.update();
      this.interval = setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    update() {
      const now = Date.now();
      const diff = this.endDate.getTime() - now;

      if (diff <= 0) {
        clearInterval(this.interval);
        const section = this.closest('.pdp-price__countdown-section');
        if (section) section.style.display = 'none';
        return;
      }

      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      const pad = (n) => String(n).padStart(2, '0');

      if (this.daysEl) this.daysEl.textContent = pad(days);
      if (this.hoursEl) this.hoursEl.textContent = pad(hours);
      if (this.minutesEl) this.minutesEl.textContent = pad(minutes);
      if (this.secondsEl) this.secondsEl.textContent = pad(seconds);
    }
  }

  customElements.define('pdp-countdown', PdpCountdown);
}